var map = {
	"./4-banner_bg.png": "5a5b",
	"./6-images_bg.png": "9314",
	"./q1.png": "b45d",
	"./q2.png": "bec0",
	"./q3.png": "5fe6",
	"./q4.png": "cd60",
	"./q5.png": "f847",
	"./quanwei_bg.png": "db8b",
	"./t1.png": "1ded",
	"./t2.png": "d635",
	"./t3.png": "d1a5",
	"./t4.png": "7e90",
	"./zixun.png": "6b6e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "072c";